// extracted by mini-css-extract-plugin
module.exports = {"container":"Background_container_2qXjU","title":"Background_title_2IWeF","desc":"Background_desc_2Oglw"};